import { GetMostRecentTaskGroup, SaveMostRecentTaskGroup } from "../src/PortalTaskStateMgr";
import { GroupBy, TaskCard } from "../views/Home/Index/cardSorting";

export function GetTaskId() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("taskId");
}

export async function GoToRecentTaskGroup() {
    GoToTaskGroupPage(await GetMostRecentTaskGroup(), GroupBy.WorkItemId);
}

export function GoToTaskGroupPage(groupKey: string, groupMethod:GroupBy) {
    let params = new URLSearchParams();
    params.append("gm", groupMethod.toString());
    params.append("group", groupKey ?? "");

    SaveMostRecentTaskGroup(groupKey, groupMethod);

    location.href = `${location.origin}/Home/Tasks?${params}`;
}

export function GoToHomePage() {
    location.href = `${location.origin}/Home`;
}

export function GetTaskByKeyParameterFromQueryString(): IGetTasksByKeyRequest{

    const urlParams = new URLSearchParams(window.location.search);

    return {
        GroupMethod:parseInt(urlParams.get("gm")),
        KeyId:urlParams.get("group")
    };
}


export function GetTaskUrl(taskId:string){
    return `/PortalTask?taskId=${taskId}`;
}